import { Box, Flex, Grid, Text, Center } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
import { ThemeContext } from './context/ThemeProvider';
import { FaCreativeCommons } from 'react-icons/fa';
import {  Link as ScrollLink } from "react-scroll";
import { Link } from 'react-router-dom';

const Footer = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Box style={theme ? { color: 'black' } : { color: 'white' }} p={{ xl: '0 15vh 0 17vh', base: '5vh' }}>
      <Flex justify={{ md: 'space-between', base: 'space-around' }}>
        <Flex gap={{ md: '6vh', base: '2vh' }} direction={{ base: 'column', md: 'row' }}>
          <Text fontWeight={'bold'}>Mohd Asim</Text>
          <ScrollLink to="about"  >
            <Text cursor={'pointer'}>About</Text>
          </ScrollLink>
          <ScrollLink to="skills">
            <Text cursor={'pointer'}>Skills</Text>
          </ScrollLink>
          <ScrollLink to="projects">
            <Text cursor={'pointer'}>Project</Text>
          </ScrollLink>
        </Flex>

        <Grid templateColumns={{ xl: 'repeat(3, 1fr)', lg: 'repeat(3, 1fr)', base: 'repeat(1, 1fr)' }} fontSize={20} gap={{ md: '2vh', base: 0 }}>
          <Link to="https://www.linkedin.com/in/mohd-asim-8688061b2/"><AiFillLinkedin color='blue' /></Link>
          <Link to="https://github.com/Asimji"><AiFillGithub color='gray' /></Link>
          <Link><AiFillInstagram color='#8730bc' /></Link>
        </Grid>
      </Flex>

      <Box borderBottom={'2px solid gray'} mb={'5vh'} mt={'2vh'}></Box>
      <Center fontWeight={'bold'}>
        <span style={{ marginRight: '1vh' }}><FaCreativeCommons /></span> 2023 Mohd Asim. All rights reserved
      </Center>
    </Box>
  );
};

export default Footer;
